import React, { useState, useEffect, useCallback, useContext } from 'react'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import axios from "axios";
const Main = () => {
  const containerStyle = {
    width: '100vw', // ビューポートの幅全体
    height: '100vh' // ビューポートの高さ全体
  };



  const [latA, setLatA] = useState(35.534692); // 初期値を適当な値に設定
  const [lngA, setLngA] = useState(139.725019); // 初期値を適当な値に設定

  const [latB, setLatB] = useState(35.534692); // 初期値を適当な値に設定
  const [lngB, setLngB] = useState(139.725149); // 初期値を適当な値に設定 

  const [center, setCenter] = useState({ lat: 35.534692, lng: 139.725019 });




  const urlA = "https://tictac-clip.com/api/get_gps/?gpsId=440103269649271";
  const urlB = "https://tictac-clip.com/api/get_gps/?gpsId=440103269847361";
  const getGpsA = async () => {
    try {
      const res = await axios.get(urlA);



      let newLat = res.data[0][0];
      let newLng = res.data[0][1];




      if (newLat == "") {
        newLat = res.data[1][0];
        newLng = res.data[1][1];


      }

      if (newLat == "") {
        newLat = res.data[2][0];
        newLng = res.data[2][1];

      }

      if (newLat == "") {
        newLat = res.data[3][0];
        newLng = res.data[3][1];


      }
      if (newLat != "") {
        newLat = parseFloat(newLat);
        newLng = parseFloat(newLng);
        setLatA(newLat);
        setLngA(newLng);
        setCenter({ lat: newLat, lng: newLng });
      }
      if (newLat == "") {




        //https://tictac-clip.com/media/440103269649271.txtを取得
        const url = "https://tictac-clip.com/media/440103269649271.txt";
        try {
          const res = await axios.get(url);
          console.log(res.data);

          let gpsData = res.data.split(",");
          newLat = parseFloat(gpsData[0]);
          newLng = parseFloat(gpsData[1]);
          setLatA(newLat);
          setLngA(newLng);
          console.log("onLineA")
          setCenter({ lat: newLat, lng: newLng }); // 地図の中心をAPIからの応答に更新
        }
        catch (error) {
          setLatA(latA);
          setLngA(lngA);

          console.error("GPS data fetch error:", error);
          setCenter({ lat: newLat, lng: newLng }); // 地図の中心をAPIからの応答に更新
        }
      }







      console.log("GPS data fetch success:", res.data);

    } catch (error) {
      console.error("GPS data fetch error:", error);
    }

  }

  const getGpsB = async () => {
    try {
      const res = await axios.get(urlB);


      let newLat = res.data[0][0];
      let newLng = res.data[0][1];


      if (newLat == "") {
        newLat = res.data[1][0];
        newLng = res.data[1][1];

      }

      if (newLat == "") {
        newLat = res.data[2][0];
        newLng = res.data[2][1];
      }

      if (newLat == "") {
        newLat = res.data[3][0];
        newLng = res.data[3][1];

      }
      if (newLat != "") {
        newLat = parseFloat(newLat);
        newLng = parseFloat(newLng);
        setLatB(newLat);
        setLngB(newLng);


      }

      if (newLat == "") {




        //https://tictac-clip.com/media/440103269649271.txtを取得
        const url = "https://tictac-clip.com/media/440103269847361.txt";
        try {
          const res = await axios.get(url);
          console.log(res.data);

          let gpsData = res.data.split(",");
          newLat = parseFloat(gpsData[0]);
          newLng = parseFloat(gpsData[1]);
          setLatB(newLat);
          setLngB(newLng);
          console.log("onLineB")

        }
        catch (error) {
          setLatB(latB);
          setLngB(lngB);

          console.error("GPS data fetch error:", error);

        }
      }


      console.log("GPS data fetch success:", res.data);

    } catch (error) {
      console.error("GPS data fetch error:", error);
    }

  }


  useEffect(() => {
    //１秒後にgetGpsAを実行

    getGpsA();
    getGpsB();
    const timer = setInterval(() => {
      getGpsA();
      getGpsB();
    }, 60000);

  }, []);



  const [map, setMap] = useState(null);

  const onLoad = useCallback(function callback(map) {



  }, []);

  const onUnmount = useCallback(function callback(map) {

  }, []);

  const mapStyles = [
    {
      featureType: "all",
      elementType: "labels",

    },
    {
      featureType: "transit.station",
      elementType: "labels",
      stylers: [{ visibility: "on" }]
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "on" }]
    }
  ];

  const options = {
    styles: mapStyles,
    streetViewControl: false, // ストリートビューのボタンを非表示
    zoomControl: false,       // ズームコントロールを非表示
    mapTypeControl: false,    // マップタイプコントロールを非表示    
    // その他のUI要素も同様に制御可能
  };
  const customIcon = {
    url: 'https://ha-app.com/m1.png', // アイコンのURL

  };
  const customIcon2 = {
    url: 'https://ha-app.com/m2.png', // アイコンのURL

  };

  return (
    <div>
      <LoadScript
        googleMapsApiKey="AIzaSyDyn-GCfgexZ61pUQ9-64TPWT5dkugImgs"
        libraries={["visualization"]}
      >
        <GoogleMap
          onLoad={onLoad}
          mapContainerStyle={containerStyle}
          center={center}
          zoom={19}
          options={options}
        >
          {/* マーカーの位置を動的に変更 */}
          <Marker
            position={{ lat: latA, lng: lngA }}
            icon={customIcon}
          />
          <Marker
            position={{ lat: latB, lng: lngB }}
            icon={customIcon2}
          />
        </GoogleMap>
      </LoadScript>
    </div>
  );
}

export default Main;
